/**
 * Creates a dictionary from an array of records where key is the field from the
 * array entry record.
 *
 * @example
 *   const result = arrayToDictionary(
 *     [
 *       { id: 'id1', name: 'foo' },
 *       { id: 'id2', name: 'bar' },
 *     ],
 *     'id',
 *   );
 *
 *   // const result = {
 *   //  id1: { id: 'id1', name: 'foo' },
 *   //  id2: { id: 'id2', name: 'bar' },
 *   // };
 *
 * @param array The array of records.
 * @param key The key to use in the result record.
 */
export function arrayToDictionary<
  TArray extends readonly Record<string, unknown>[] | Record<string, unknown>[],
  TItem extends TArray[number],
  TKey extends keyof TItem,
>(array: TArray, key: TKey): Record<string, TItem> {
  return Object.fromEntries(
    array.map((entry) => [entry[key as string], entry]),
  );
}
